import { Component, Input, ViewChild, ViewContainerRef } from '@angular/core';
@Component({
    selector: 'icon-fds',
    template: `
        <ng-template #template>
            <svg width="20" height="20" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg" [ngClass]="class">
                <path
                    d="M7.44375 0H0.109375V16H12.1094V4.66563H7.44375V0ZM9.44375 10V11.3344H6.77812V14H5.44375V11.3344H2.77812V10H5.44375V7.33437H6.77812V10H9.44375ZM8.10938 0V4H12.1094L8.10938 0Z"
                    fill="currentColor"
                />
            </svg>
        </ng-template>
    `,
})
export class IconFdsComponent {
    @Input() class: any = '';
    @ViewChild('template', { static: true }) template: any;
    constructor(private viewContainerRef: ViewContainerRef) {}
    ngOnInit() {
        this.viewContainerRef.createEmbeddedView(this.template);
        this.viewContainerRef.element.nativeElement.remove();
    }
}
